<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesMstKamResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" import-enabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <!--                                        <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-file-import"-->
                                    <!--                                            :disabled= false-->
                                    <!--                                            custom-label="导入KAM"-->
                                    <!--                                            v-bind:class="'btn btn-outline-primary btn-sm'"-->
                                    <!--                                            v-b-modal.modal-updateProjectPlan>-->
                                    <!--                                        </em-button>-->
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <b-modal id="modal-updateProjectPlan" title="导入KAM" hide-footer>
            <b-form @submit="handleSubmit" @reset="handleReset">
                <b-form-group
                    id="templateFile"
                    label="选择数据源文件:"
                    label-for="input-dataFile"
                    invalid-feedback="必须选择数据源">
                    <b-form-file id="input-dataFile" v-model="file" ref="file-input" class="mb-2"
                                 :browse-text="$t('btn.basic.browse')" placeholder="请选择数据文件"
                                 :file-name-formatter="formatNames" accept=".xlsx" required></b-form-file>
                </b-form-group>

                <div class="form-check mt-2">
                    <input class="form-check-input is-invalid" type="checkbox" value="" id="agreement"
                           aria-describedby="invalidCheckFeedback" required>
                    <label class="form-check-label" for="agreement">确认覆盖原始数据</label>
                    <div id="invalidCheckFeedback" class="invalid-feedback">请确认</div>
                </div>

                <b-row align-h="end" style="margin-top: 30px">
                    <b-button type="submit" variant="primary">导入</b-button>
                    <b-button type="reset" variant="light">取消</b-button>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
// Author Lin
// Date 2021-03-17 16:14:14

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
    name: "sithMesMstKamListView",
    mixins: [emCommonListMixin, emCommonApiMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    data() {
        return {
            file: null
        }
    },
    methods: {
        handleSubmit(event) {
            event.preventDefault()
            var formData = new FormData();
            formData.append('file', this.file);

            this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi(this.modelName)}/updateData`, formData)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "更新成功")
                    this.$refs.emListFilter.doQuery()
                })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-updateProjectPlan')
            })
        },
        handleReset() {
            this.file = null;
            this.$nextTick(() => {
                this.$bvModal.hide('modal-updateProjectPlan')
            })
        },
    }
};
</script>